import styled, { css } from 'styled-components';
import { spacing, colors, subtleShadow } from 'ui/theme';
import { Button, IconButton } from 'ui/button';
import { OverflowPageButtonProps, PaginationVariant } from './types';

/**
 * Pagination Buttons
 */
export const DISABLED_BUTTON_STYLES = {
  [PaginationVariant.Purple]: css`
    &&&& {
      background: ${colors.purple10};
      color: ${colors.purple90};
      ${subtleShadow}
      border: ${spacing.single} solid ${colors.purple20};
    }
  `,
  [PaginationVariant.Grey]: css`
    &&&& {
      background: ${colors.grey5};
      color: ${colors.textPrimary};
      box-shadow: none;
      border: ${spacing.single} solid ${colors.grey5};
    }
  `,
};

export const PAGINATION_NUM_VARIANT_STYLES = {
  [PaginationVariant.Purple]: css`
    &&&:focus:before {
      border-color: ${colors.purple100};
    }
    &&:hover {
      border: ${spacing.single} solid ${colors.purple50};
      background: ${colors.white};
    }
  `,
  [PaginationVariant.Grey]: css`
    && {
      color: ${colors.grey50};
      box-shadow: none;
    }
    &&&:focus:before {
      border-color: ${colors.grey15};
    }
    &&:hover {
      border: ${spacing.single} solid ${colors.grey15};
      background: ${colors.white};
    }
  `,
};

export const PaginationButton = styled(Button)`
  ${({ isDisabled, pageVariant }: { isDisabled: boolean; pageVariant: PaginationVariant }) =>
    isDisabled && (DISABLED_BUTTON_STYLES[pageVariant] || ``)};
  ${({ pageVariant }) => PAGINATION_NUM_VARIANT_STYLES[pageVariant] || ``};
  box-shadow: none;
`;

export const OverflowButton = styled.div<{
  $pageVariant: OverflowPageButtonProps['pageVariant'];
}>`
  background: ${colors.white};
  border-radius: ${spacing.quarter};
  border: ${spacing.single} solid #e0dedf;
  color: ${({ $pageVariant }) =>
    $pageVariant === PaginationVariant.Grey ? colors.grey50 : colors.textPrimary};
  display: grid;
  padding: 0 ${spacing.threeQuarter};
  place-content: center;
  user-select: none;
`;

/**
 * Pagination Arrows
 */
const DISABLED_ARROW_STYLE = css`
  &&&& {
    background: ${colors.white};
    box-shadow: none;
    border: none;
  }
`;

export const PAGINATION_ARROW_VARIANT_STYLES = {
  [PaginationVariant.Purple]: css`
    &&:focus:before {
      border-color: ${colors.purple100};
    }
  `,
  [PaginationVariant.Grey]: css`
    &&:focus:before {
      border-color: ${colors.grey15};
    }
  `,
};

export const PaginationArrow = styled(IconButton)`
  && {
    ${({ isDisabled }: { isDisabled: boolean; pageVariant: PaginationVariant }) =>
      isDisabled && DISABLED_ARROW_STYLE};
    box-shadow: none;
    svg path {
      stroke: ${colors.textPrimary};
    }
    ${({ pageVariant }) => PAGINATION_ARROW_VARIANT_STYLES[pageVariant] || ``};
  }
`;

export const PaginationButtons = styled.span`
  display: inline-flex;
  padding: 0 ${spacing.base};
  gap: ${spacing.quarter};
`;
